<p class="simple-drawer-text">
 {{message}}
</p>
<div class="simple-drawer-button-container">
  <button nz-button (click)="this.toExecFunction()" class="mobile-purple-sales-button">
    <p class="purple-sales-button-text">
      {{buttonText}}
    </p>
  </button>
</div>